import type { RequestParams, ScpClient } from '~shared/api/scp/client';

import type { ExtendedApplication } from '../../model/application';
import type { FindApplicationsRequestParams } from '../../model/find-applications-params';
import type { FindApplicationsResponse } from '../../model/find-applications-response';
import type { ApplicationsApi } from '../applications-api';

interface Params {
  scpClient: ScpClient;
  host: string;
}

export class GatewayApplicationsApi implements ApplicationsApi {
  host: string;
  client: ScpClient;

  constructor({ scpClient, host }: Params) {
    this.client = scpClient;
    this.host = host;
  }

  async findApplications(
    params: FindApplicationsRequestParams
  ): Promise<FindApplicationsResponse> {
    return this.makeRequest<FindApplicationsResponse>({
      method: 'applications',
      payload: params,
    }).then((response) => response.payload);
  }

  async getApplicationById(
    applicationId: string
  ): Promise<ExtendedApplication> {
    return this.makeRequest<ExtendedApplication>({
      method: 'applications/get-by-id',
      payload: { applicationId },
    }).then((response) => response.payload);
  }

  async generateReport(
    params: FindApplicationsRequestParams
  ): Promise<{ reportId: string }> {
    return this.makeRequest<{ reportId: string }>({
      method: 'run-applications-export',
      payload: params,
    }).then((response) => response.payload);
  }

  private makeRequest<T = unknown>(
    params: Partial<RequestParams> & { method: string }
  ) {
    return this.client.call<T>({
      host: this.host,
      version: 'v1',
      domain: 'merchant-portal',
      service: 'public/dashboard',
      withCredentials: true,
      withLeadingDomain: true,
      ...params,
    });
  }
}
